define('oaConfig',[
	"underscore",
	"underscore-string",
],

function (_, _S) {
	/**
	 * A global object for storing information about the current configurations for OpenAnnotate.
	 * @alias OAConfig
	 */
	var OAConfig = _.extend({
		addConfigurableProps: function(actionName, actionGroup) {

			var dropdownLabelStr = "dropdownLabel-";
			var dropdownIconStr = "dropdownIcon-";
			var isType = false;

			if (_S.startsWith(actionName,"t:")) {
				// Any of our types
				actionName = actionName.substring(2).trim();
				isType = true;
				this.enabledActionTypes.push(actionName);
			} else if (_S.startsWith(actionName,"--")) {
				// Any configurable property
				actionName = actionName.substring(2).trim();
				if (_S.startsWith(actionName,"dropdownLabel")) {
					actionGroup["dropdownLabel"] = actionName.substring(dropdownLabelStr.length);
				} else if (_S.startsWith(actionName,"dropdownIcon")) {
					actionGroup["dropdownIcon"] = actionName.substring(dropdownIconStr.length);
				} else if (_S.startsWith(actionName,"dropdownShowSelected")) {
					actionGroup["dropdownShowSelected"] = true
				} else if (_S.startsWith(actionName,"sidebar")) {
					actionGroup["sidebar"] = true;
				} else {						
					actionGroup[actionName] = true;
				} 
				return;
			} else {
				// Just a normal action
				this.enabledButtons.push(actionName, actionGroup);
			}

			actionGroup["actions"].push({
				actionName : actionName,
				isType : isType
			});
		},

		/**
		* Parses properties setup in defaults.properties
		*/
		parseProps: function() {

			this.actionGroupInfo = [];
			this.enabledActionTypes = [];
			this.enabledButtons = [];
			var self = this;
			
			//regex to grab each toolbar group (surrounded by parenthesis)
			var patt = /\((.*?)\)/g;
			
			// setup a default object
			var actionGroupDefaults = {
				"dropdownLabel":"",
				"dropdownIcon":"chevron-down",
				"isSmallScreen":false,
				"showAtAllSizes":false,
				"sidebar":false
			};

			// if .exec() returns a non-null value then we have a group to
			// iterate and format.  The actionGroupInfo object will later
			// be used to create views/models for the toolbar 
			var match = patt.exec(this[this.enabledButtonsString])
			while (!_.isNull(match)) {
				var actionGroup = {"actions":[]};
				actionGroup = _.defaults(actionGroup, actionGroupDefaults);
				// Are we a dropdown or not
				if (match.index !== 0 && this[this.enabledButtonsString].charAt(match.index - 1) === 'd') {
					// if a 'd' surrounds the group then we know it is a dropdown
					actionGroup["isDropdown"] = true;
				} else {
					actionGroup["isDropdown"] = false;
				}		
				// Get rid of the leading and training parenthesis, then split by comma to get each individual item (action or type) in the group
				var items = match[1].trim().split(',');
				_.each(items, function(item) {
					self.addConfigurableProps(item.trim(), actionGroup);
				});

				this.actionGroupInfo.push(actionGroup);

				match = patt.exec(this[this.enabledButtonsString])
			}
		}

	}, window.ConfigurationVariables);
	
	OAConfig.parseProps();
	
	return OAConfig;
});


